/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CalendarEventResponseListResponse } from '../models/calendar-event-response-list-response';
import { getFeV1Calendar$Json } from '../fn/calendar/get-fe-v-1-calendar-json';
import { GetFeV1Calendar$Json$Params } from '../fn/calendar/get-fe-v-1-calendar-json';
import { getFeV1Calendar$Plain } from '../fn/calendar/get-fe-v-1-calendar-plain';
import { GetFeV1Calendar$Plain$Params } from '../fn/calendar/get-fe-v-1-calendar-plain';
import { getFeV1CalendarSearchableYears$Json } from '../fn/calendar/get-fe-v-1-calendar-searchable-years-json';
import { GetFeV1CalendarSearchableYears$Json$Params } from '../fn/calendar/get-fe-v-1-calendar-searchable-years-json';
import { getFeV1CalendarSearchableYears$Plain } from '../fn/calendar/get-fe-v-1-calendar-searchable-years-plain';
import { GetFeV1CalendarSearchableYears$Plain$Params } from '../fn/calendar/get-fe-v-1-calendar-searchable-years-plain';
import { SearchableYearsResponse } from '../models/searchable-years-response';

@Injectable({ providedIn: 'root' })
export class CalendarService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getFeV1CalendarSearchableYears()` */
  static readonly GetFeV1CalendarSearchableYearsPath = '/v1/calendar/searchable-years';

  /**
   * Gets all years that have searchable events.
   *
   * Gets all years that have searchable events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1CalendarSearchableYears$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1CalendarSearchableYears$Plain$Response(params?: GetFeV1CalendarSearchableYears$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchableYearsResponse>> {
    return getFeV1CalendarSearchableYears$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all years that have searchable events.
   *
   * Gets all years that have searchable events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1CalendarSearchableYears$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1CalendarSearchableYears$Plain(params?: GetFeV1CalendarSearchableYears$Plain$Params, context?: HttpContext): Observable<SearchableYearsResponse> {
    return this.getFeV1CalendarSearchableYears$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchableYearsResponse>): SearchableYearsResponse => r.body)
    );
  }

  /**
   * Gets all years that have searchable events.
   *
   * Gets all years that have searchable events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1CalendarSearchableYears$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1CalendarSearchableYears$Json$Response(params?: GetFeV1CalendarSearchableYears$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SearchableYearsResponse>> {
    return getFeV1CalendarSearchableYears$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets all years that have searchable events.
   *
   * Gets all years that have searchable events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1CalendarSearchableYears$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1CalendarSearchableYears$Json(params?: GetFeV1CalendarSearchableYears$Json$Params, context?: HttpContext): Observable<SearchableYearsResponse> {
    return this.getFeV1CalendarSearchableYears$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SearchableYearsResponse>): SearchableYearsResponse => r.body)
    );
  }

  /** Path part for operation `getFeV1Calendar()` */
  static readonly GetFeV1CalendarPath = '/v1/calendar';

  /**
   * Gets calendar events for a specific month.
   *
   * Gets calendar events for a specific month.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Calendar$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Calendar$Plain$Response(params?: GetFeV1Calendar$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponseListResponse>> {
    return getFeV1Calendar$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets calendar events for a specific month.
   *
   * Gets calendar events for a specific month.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Calendar$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Calendar$Plain(params?: GetFeV1Calendar$Plain$Params, context?: HttpContext): Observable<CalendarEventResponseListResponse> {
    return this.getFeV1Calendar$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponseListResponse>): CalendarEventResponseListResponse => r.body)
    );
  }

  /**
   * Gets calendar events for a specific month.
   *
   * Gets calendar events for a specific month.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFeV1Calendar$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Calendar$Json$Response(params?: GetFeV1Calendar$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CalendarEventResponseListResponse>> {
    return getFeV1Calendar$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Gets calendar events for a specific month.
   *
   * Gets calendar events for a specific month.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getFeV1Calendar$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFeV1Calendar$Json(params?: GetFeV1Calendar$Json$Params, context?: HttpContext): Observable<CalendarEventResponseListResponse> {
    return this.getFeV1Calendar$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CalendarEventResponseListResponse>): CalendarEventResponseListResponse => r.body)
    );
  }

}
